<template>
  	<FlexPinListBatchWise />
</template>

<script>

// @ is an alias to /src
import FlexPinListBatchWise from "@/components/Flex/PinListBatchWise.vue";

export default {
  name: "FlexPinListBatchWises",
  components: {
    FlexPinListBatchWise,
  },
};
</script>
